<template>
  <div class="container">
    <div class="nav" v-if="!userAgent">
      <!-- logo -->
      <div class="img">
        <img src="@/assets/images/logo.png" alt />
      </div>
      <!-- 导航条 -->
      <div class="list">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="/home">网站首页</el-menu-item>
          <el-submenu index="/about">
            <template slot="title">
              <span @click="toLink('/about?a=0')">关于赛捷</span>
            </template>
            <el-menu-item
              :index="'/about?a=' + index"
              v-for="(item,index) in about"
              :key="index"
            >{{item.category_name}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-submenu index="/serve">
            <template slot="title">
              <span @click="toLink('/serve?b=0')">服务内容</span>
            </template>
            <el-menu-item
              :index="'/serve?b=' + index"
              v-for="(item,index) in server"
              :key="index"
            >{{item.category_name}}</el-menu-item>
          </el-submenu>
          <el-submenu index="/show">
            <template slot="title">
              <span @click="toLink('/show?c=0')">案例展示</span>
            </template>
            <el-menu-item
              :index="'/show?c=' + index"
              v-for="(item,index) in show"
              :key="index"
            >{{item.name}}</el-menu-item>
          </el-submenu>
          <el-submenu index="/news">
            <template slot="title">
              <span @click="toLink('/news?d=0')">新闻动态</span>
            </template>
            <el-menu-item
              :index="'/news?d=' + index"
              v-for="(item,index) in news"
              :key="index"
            >{{item.name}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div v-else class="mobile">
      <!-- 导航 -->
      <div class="daohang">
        <div class="logo">
          <el-menu @open="handleOpen" @close="handleClose" mode="horizontal" :router="true">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-menu"></i>
              </template>
              <el-menu-item index="/home">
                <span slot="title">首页</span>
              </el-menu-item>
              <el-submenu index="3-1">
                <template slot="title">关于赛捷</template>
                <el-menu-item
                  :index="'/about?a=' + index"
                  v-for="(item,index) in about"
                  :key="index"
                >{{item.category_name}}</el-menu-item>
              </el-submenu>
              <el-menu-item index="/product">
                <span slot="title">产品中心</span>
              </el-menu-item>
              <el-submenu index="5-1">
                <template slot="title">服务内容</template>
                <el-menu-item
                  :index="'/serve?b=' + index"
                  v-for="(item,index) in server"
                  :key="index"
                >{{item.category_name}}</el-menu-item>
              </el-submenu>
              <el-submenu index="6-1">
                <template slot="title">案例展示</template>
                <el-menu-item
                  :index="'/show?c=' + index"
                  v-for="(item,index) in show"
                  :key="index"
                >{{item.name}}</el-menu-item>
              </el-submenu>
              <el-submenu index="7-1">
                <template slot="title">新闻动态</template>
                <el-menu-item
                  :index="'/news?d=' + index"
                  v-for="(item,index) in news"
                  :key="index"
                >{{item.name}}</el-menu-item>
              </el-submenu>
              <el-menu-item index="/contact">
                <span slot="title">联系我们</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div class="logoImg">
          <img src="@/assets/images/logo.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "my-nav",
  data() {
    return {
      activeIndex: "/home",
      about: [],
      server: [],
      show: [],
      news: [],
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
      this.$router.push(key);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    toLink: function (url) {
      this.activeIndex = url;
      this.$router.push(url);
    },
    getGuanyu: function () {
      //关于赛捷  二级导航菜单
      let that = this;
      that.$http.get("about/index_all").then(function (res) {
        that.about = res.data.data;
      });
    },
    getServer: function () {
      //服务内容
      //服务内容  二级导航菜单
      let that = this;
      that.$http.get("services/index_all").then(function (res) {
        that.server = res.data.data;
      });
    },
    getShow: function () {
      //案例展示
      //案例展示  二级导航菜单
      let that = this;
      that.$http.get("cases/index").then(function (res) {
        that.show = res.data.data;
      });
    },
    getNews: function () {
      //新闻动态  二级导航菜单
      let that = this;
      that.$http.get("news/index").then(function (res) {
        that.news = res.data.data;
      });
    },
  },
  watch: {
    $route: {
      handler() {
        let url_arr = window.location.href.split("/");
        this.activeIndex = "/" + url_arr[url_arr.length - 1];
      },
      deep: true,
    },
  },
  created: function () {
    this.$root.newVue.$on("nav_index", (data) => {
      this.activeIndex = data;
    });
  },
  mounted: function () {
    let url_arr = window.location.href.split("/");
    this.activeIndex = "/" + url_arr[url_arr.length - 1];
    console.log(this.activeIndex);
    this.getGuanyu();
    this.getServer();
    this.getShow();
    this.getNews();
  },
};
</script>
<style lang='scss' scoped>
.nav {
  width: 80%;
  margin: 1% auto;
  display: flex;
  .img {
    width: 20%;
    img {
      width: 62px;
      height: 53px;
    }
  }
  .list {
    width: 80%;
    display: flex;
  }
}
</style>
<style >
.nav .el-menu-demo {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.nav .el-menu.el-menu--horizontal {
  border: 0;
}
.nav .el-menu--horizontal > .el-menu-item a,
.el-menu--horizontal > .el-menu-item a:hover {
  text-decoration: none;
}
.nav .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #43ae82;
  color: #43ae82;
}

.nav .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #43ae82;
  color: #43ae82;
}
.nav .el-submenu__title * {
  text-decoration: none;
}
.nav .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow::before {
  content: "";
}
.nav .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #43ae85 !important;
}
/* 有子导航时hover为绿色 */
.nav .el-submenu__title *:hover {
  color: #43ae82 !important;
}
.nav .el-menu--horizontal > .el-submenu:hover {
  color: #43ae82 !important;
}
.nav .router-link-exact-active {
  color: #43ae82;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active {
  color: #43ae82 !important;
}
.el-menu--popup-bottom-start .el-menu-item {
  border-bottom: 1px solid #e4e4e4;
}
.nav .el-menu-item:hover {
  color: #43ae82;
}
.el-menu--popup {
  padding: 0 !important;
  min-width: 125px !important;
}
.nav .el-menu--horizontal > .el-menu-item,
.nav .el-submenu__title * {
  font-weight: bold;
  color: #333333;
  font-size: 17px;
}
.nav .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #333 !important;
}
.nav .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #43ae85 !important;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #333 !important;
  font-size: 14px;
  height: 40px !important;
  line-height: 40px;
  border-bottom: 1px dashed #ddd;
}

.nav .is-active .el-submenu__title > span {
  color: #43ae82 !important;
}
.el-col-12 {
  width: 0 !important;
}
.el-row {
  border: 1px solid #eee;
}
.el-menu-item.is-active {
  color: #43ae85 !important;
}
</style>
<style lang="scss" scoped>
.daohang {
  display: flex;
  .logo {
    width: 80%;
  }
  .logoImg {
    padding-top: 1.4rem;
    width: 20%;
    img {
      height: 1.5rem;
      padding-left: 1rem;
    }
  }
}
</style>
<style lang="scss">
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: none !important;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}
.el-menu--horizontal .el-submenu.is-active .el-submenu__title {
  border-bottom-color: none !important;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: #ddd !important;
}
</style>

